module.exports = __webpack_public_path__ + "img/money_bag.efe69a8d.png";